import React from 'react';
import clsx from 'clsx';

import { logEvent } from '../../lib/analytics';
import { BoringAvatar } from '../BoringAvatar';

interface VoiceCardProps {
  image: string;
  title: string;
  onClick?: () => void;
  isPlaceholder?: boolean;
  isSelected?: boolean;
  isSizeLarge?: boolean;
  languageCode: string;
  gender: string;
}

export const VoiceCard = ({
  languageCode,
  image,
  title,
  onClick,
  isPlaceholder,
  isSelected,
  isSizeLarge,
  gender,
}: VoiceCardProps) => {
  return (
    <button
      key={title}
      type="button"
      disabled={isPlaceholder}
      onClick={() => {
        logEvent('voice_updated', {
          voice_name: title,
          language: languageCode,
        });
        onClick?.();
      }}
      className={clsx(
        'z-80 group relative flex w-full items-center gap-3 rounded-2xl border-0 px-3 py-[6px] outline-none duration-300 hover:bg-[#E9EAF0]',
        {
          'cursor-pointer': !isPlaceholder,
          'md:gap-4': isSizeLarge,
        },
      )}>
      <div
        className={clsx(
          'relative flex min-h-8 min-w-8 overflow-hidden rounded-full',
          {
            'border-[#2239FC]': isSelected,
            'border-transparent group-focus:border-[#2239FC]/50': !isSelected,
          },
        )}>
        <span className="absolute inset-0 bg-[#1e1a38] opacity-0 transition-opacity group-hover:opacity-[7%]" />
        {!image.length ? (
          <BoringAvatar />
        ) : (
          <img
            src={image}
            className="min-h-8 min-w-8 rounded-full bg-[#f0f4f9]"
            alt={title}
            width={32}
            height={32}
          />
        )}
      </div>
      <div className="@sxm:mr-[14px] mr-0 flex w-full items-center whitespace-nowrap text-[1rem]">
        {title}
        &nbsp;
        <span className="hidden @xsm:inline">
          {'(' + gender.charAt(0).toUpperCase() + ')'}
        </span>
      </div>
    </button>
  );
};
